"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUsers = void 0;
const utilities_1 = require("@/utilities");
const parseUserRoles_1 = require("./parseUserRoles");
function buildUsers(users, hasOperation) {
    return users
        .map((user) => {
        const parsedUser = {
            id: user.id,
            username: (0, utilities_1.capitalize)(user.username, true),
            email: user.email,
            roles: (0, parseUserRoles_1.parseUserRoles)(user?.roles),
            department: user.department,
        };
        if (hasOperation) {
            return {
                ...parsedUser,
                operation: null,
            };
        }
        return parsedUser;
    })
        .sort((previous, next) => {
        return previous.username.localeCompare(next.username);
    });
}
exports.buildUsers = buildUsers;
